define.alias("shared/components/shared/social-identity/item", "calendar/components/shared/social-identity/item");